<template>
  <div class="list-app">
    <div class="field">
      <n-text-input
        v-model="value.heading"
        label="Heading"
        :errorMessage="getErrorMessage('heading', 'Heading')"
        @input="() => markAsTouched('heading')"
      />
    </div>

    <div v-for="(item, index) of value.items" :key="index" class="list-app__item">
      <ContentHighlightsListItemEdit
        :model-value="item"
        :item-index="index"
        :total-items="value.items.length"
        @remove="removeItem(index)"
        @update:modelValue="onItemUpdate"
      />
    </div>
    <div class="list-app__actions">
      <n-button-group>
        <n-button variant="primary" @click="addItem">Add Item</n-button>
      </n-button-group>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useVuelidate from '@vuelidate/core';
import { helpers, required, url } from '@vuelidate/validators';
import { ListApp, ListAppItem } from './models/ListApp';
import ContentHighlightsListItemEdit from './ContentHighlightsListItemEdit.vue';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';

function onItemUpdate(item: ListAppItem, index: number) {
  value.value.items[index] = item;
  emit('isInvalid', $v.value.$invalid);
}

const props = defineProps({
  modelValue: {
    type: Object as PropType<ListApp>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: ListApp): void;
  (e: 'isInvalid', value: boolean): void;
}>();
const value = useVModel(props, 'modelValue', emit);

const validations = {
  heading: { required },
};

const $v = useVuelidate(validations, value);

function markAsTouched(key: keyof ListApp) {
  const field = $v.value[key];
  if (field) {
    field.$touch();
  }
  emit('isInvalid', $v.value.$invalid);
}

function getErrorMessage(fieldName: string & keyof ListApp, label: string): string | null {
  return VuelidateUtil.getErrorMessage($v, fieldName, label);
}

function addItem() {
  value.value.items.push({
    url: '',
    description: '',
    label: '',
    image: '',
  });
  emit('isInvalid', $v.value.$invalid);
}

function removeItem(itemIndex: number) {
  if (value.value.items.length <= 1) {
    return;
  }
  value.value.items.splice(itemIndex, 1);
  emit('isInvalid', $v.value.$invalid);
}
</script>

<style scoped lang="scss">
.list-app {
  &__item {
    margin: 1rem 0;
  }
  &__actions {
    margin: 1rem 0;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
